/**
 * DisabilityService
 * Service for Disability entity operations
 * Route: api/disabilities
 * Controller: DisabilitiesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * DisabilityService
 * Handles disability CRUD operations (cached lookup table)
 * Maps to /api/disabilities endpoint
 */
export class DisabilityService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? DisabilityService.DEFAULT_SERVICE_PATH,
            basePath: DisabilityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
DisabilityService.DEFAULT_SERVICE_PATH = 'members';
DisabilityService.BASE_PATH = 'api/disabilities';
//# sourceMappingURL=DisabilityService.js.map